import {User} from '@/store/modules/users';
import store from '@/store';

export function can(permissions: string[]) {
  if (!permissions) return true;
  if (permissions.includes('dashboard')) return true;
  const user: User = store.getters['auth/user'];
  if (user !== null && permissions.length > 0) {
    const userPermissions = user?.map((item: any) => [item.name].flat()).flat();
    return userPermissions?.some((item: any) => permissions.includes(item));
  } else {
    return false;
  }
}
